import zakaria from "./../images/Team/zakaria.jpeg";
import abduallah from "./../images/Team/abduallah.jpeg";
import derya from "./../images/Team/derya1.jpg";
import Abdulrahman from "./../images/Team/abdu.jpeg";
import Khadija from "./../images/Team/Khadija.jpg";
import Ammar from "./../images/Team/Ammar.png";
import facebook from "./../images/icons/Facebook.svg";
import twitter from "./../images/icons/Twitter.svg";

export const LANGUAGES = [
  {
    name: "Türkçe",
    code: "tr",
    key: 64053,
  },
  {
    name: "English",
    code: "en",
    key: 10221,
  },
];

export const memebers = [
  {
    name: "Khadija",
    department: "Web Devlelopment",
    image: Khadija,
    facebook: facebook,
    twitter: twitter,
  },
  {
    name: "Abdullah",
    department: "Web Devlelopment",
    image: abduallah,
    facebook: facebook,
    twitter: twitter,
  },
  {
    name: "Mohammed Alalaya",
    department: "Web Devlelopment",
    image: zakaria,
    facebook: facebook,
    twitter: twitter,
  },
  {
    name: "Abdulrahaman",
    department: "Web Devlelopment",
    image: Abdulrahman,
    facebook: facebook,
    twitter: twitter,
  },
  {
    name: "Derya",
    department: "Web Devlelopment",
    image: derya,
    facebook: facebook,
    twitter: twitter,
  },
  {
    name: "Ammar",
    department: "Web Devlelopment",
    image: Ammar,
    facebook: facebook,
    twitter: twitter,
  },
];

export const LOADING_TIME = 1000;

export const USER_ID = `user_WoIweft3Igv6PR4Qav1EI`; //userID
export const TEMPLATE_ID = `template_pmbc2b2`; //templateID
